@if (!isUserLoggedIn() && goldBarItems.length > 0 && showAnnouncements) {
  <div id="announcement-container">
    <div class="row announcement">
      <div class="col-12 col-md-2 announcement-heading d-none d-md-block">
        <span translate>ALERTS.ALERTS_LINE_1</span> <span class="sub" translate> ALERTS.ALERTS_LINE_2</span>
      </div>
      <div class="col-12 col-md-10 announcement-body">
        <div class="announcement-close">
          <button type="button" class="ttp-btn-close" aria-label="Close" (click)="showAnnouncements=false"><span aria-hidden="true">×</span></button>
          <!-- <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="showAnnouncements=false"></button> -->
        </div>
        @for (goldBarItem of goldBarItems; track goldBarItem; let i = $index) {
          <div>
            <span class="fas fa-info-circle" ng-class="{'fa-exclamation': item.style == 2, 'fa-info-circle': item.style == 1}"></span>
            <span [innerHTML]="goldBarItems[i]?.name"></span> @if (goldBarItems[i]?.content) {
            <a class="read-more-link" href="javascript:void(0)" (click)="showAlertContent(goldBarItem)" (key.enter)="showAlertContent(goldBarItem)" translate>HOME.ABOUT.LEARN_MORE</a>
          }
        </div>
      }
    </div>
  </div>
</div>
}

<info-modal [id]="'alert-info-modal'"  [title]="alertTitle" [buttonText]="'MODAL.BUTTON_CLOSE'" [translate-src]="alertContent"></info-modal>
